import { Controller } from '@hotwired/stimulus';
import { Tooltip } from 'bootstrap'

export default class extends Controller {
  static values = {
    copiedText: String,
    textToCopy: String,
    withTooltip: { Boolean, default: true },
  }

  copyTextValue(event) {
    event.preventDefault();

    const targetValue = event.currentTarget.dataset.targetValue;

    navigator.clipboard.writeText(targetValue);

    if (this.withTooltipValue) {
      this.#updateTooltipWording(event.currentTarget);
    } else {
      this.#updateElementWording(event.currentTarget);
    }
  }

  #updateTooltipWording(item) {
    let tooltipContainer = item;

    tooltipContainer.setAttribute('data-bs-original-title', this.copiedTextValue);

    let btnTooltip = Tooltip.getOrCreateInstance(tooltipContainer);
    btnTooltip.show();

    setTimeout(() => {
      btnTooltip.hide();
      tooltipContainer.setAttribute('data-bs-original-title', this.textToCopyValue);
    }, 2000);
  }

  #updateElementWording(item) {
    item.textContent = this.copiedTextValue;

    setTimeout(() => {
      item.textContent = this.textToCopyValue;
    }, 3000);
  }
}
